import React from 'react';

function SupportArticleHeading({ section }) {
  return section.type === 'h2' ? (
    <h2 id={section._key}>{section.text}</h2>
  ) : (
    <h3 id={section._key}>{section.text}</h3>
  );
}

export default SupportArticleHeading;
